import React, { useState } from "react";
import { RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import AppIcons from "src/components/AppIcons";
import ComposedChart from "src/components/Charts/ComposedChart";
import DefaultContainer from "src/components/DashboardComponents/DefaultDashboardComponents/DefaultContainer";
import { useTranslation } from "src/context/Translations/context";
import useEffectFetchData from "src/hooks/useEffectFetchData";
import { ActionGroupers } from "src/pages/Actions/Panel/interface";
import HeaderDashboard from "../../../DefaultDashboardComponents/HeaderDashboard";
import { ICardConfigs } from "../../../interface";
import { colorChart, IDashboardActionsDataChart } from "../interface";

const DashboardChartActions: React.FC<ICardConfigs> = ({
	card
}) => {
	const { translate  } = useTranslation();
	const [dataActions, setDataActions] = useState<IDashboardActionsDataChart[]>([] as IDashboardActionsDataChart[]);

	const returnName = (value?: number) => {
		if(value === 1)
			return `${translate("Iniciativa")} - ${translate("Mapa")}`;
		if(value === 2)
			return `${translate("Iniciativa")} - ${translate("OKR")}`;
		if(value === 3)
			return `${translate("FCA")} - ${translate("Indicador")}`;
		if(value === 4)
			return translate("Reunião");
		if(value === 5)
			return translate("Projeto");
		if(value === 6)
			return translate("Risco");
		if(value === 7)
			return translate("Ocorrência");
		if(value === 8)
			return `${translate("Suas")} ${translate("ações")}`;
		return "";
	};

	const {loading} = useEffectFetchData<IDashboardActionsDataChart[]> (
		"DashboardActions/List", 
		{ group: true },
		({ data }) => {
			if(data && data.length > 0)
				setDataActions(data.map((dt: IDashboardActionsDataChart) => ({
					...dt,
					name: returnName(dt.group),
					color: {
						...colorChart
					} 
				})));
		}
	);


	const dataCard = dataActions && dataActions.length > 0 ? dataActions : [
		{
			canceled: 0,
			draft: 0,
			dueDateExpired: 0,
			finished: 0,
			inProgress: 0,
			notStarted: 0,
			total: 0,
			group: 8,
			name: returnName(8),
			color: {
				...colorChart
			} 
		}
	] as IDashboardActionsDataChart[];

	return (
		<DefaultContainer>
			<HeaderDashboard 
				description={card?.daa002Descricao}
				title={card && card.daa002Titulo.trim().length > 0 ? card.daa002Titulo : translate("Gráfico Ações por Origem")}
				hexColor={card?.daa002Cor !== null ? card?.daa002Cor : undefined}
				isLoading={loading}
			>
				<Link to={`/actions/panel/?group=${ActionGroupers.ORIGIN}`} >
					<RCCTooltip
						text={translate("Painel de ações")}
						color="grey"
					>
						<RCCButton
							color="transparent"
						>
							<AppIcons 
								name="actions"
								size={14}
							/>
						</RCCButton>
					</RCCTooltip>
				</Link>
				<Link to="/actions/matrix">
					<RCCTooltip
						text={translate("Matriz de ações")}
						color="grey"
					>
						<RCCButton 
							color="transparent"
							icon={{
								name: "table",
								color: "var(--app-icons-color)"
							}}
						/>
					</RCCTooltip>
				</Link>
			</HeaderDashboard>

			<RCCGrid container justifyContent="center" style={{height: "200px"}}>
				<ComposedChart
					data={dataCard as any}
					width={500}
					height={400}
					xAxis={{
						scale: "band"
					}}
					yAxis={[]}
					colorsPallete={colorChart}
					bar={[{
						dataKey: "notStarted",
						barSize: 20,
						name: translate("Não iniciadas"),
						label: { position: "top" }
					},{
						dataKey: "inProgress",
						barSize: 20,
						name: translate("Em andamento"),
						label: { position: "top" }
					},{
						dataKey: "dueDateExpired",
						barSize: 20,
						name: translate("Atrasadas"),
						label: { position: "top" }
					},{
						dataKey: "finished",
						barSize: 20,
						name: translate("Concluídas"),
						label: { position: "top" }
					}]}
				/>
			</RCCGrid>

		</DefaultContainer>
	);
};

export default DashboardChartActions;
